import { getReq } from "./instance";

export const getSchedule = async (scheduleId: string, params = {}) => {
  return getReq(`/Schedule/${scheduleId}`, params);
};
